import { AsButton, AsInput, PaymentModalHeader } from "app/subframe";
import * as React from "react";
import { usePreAuthModal } from "./usePreAuthModal";
import { motion } from "framer-motion";
import classNames from "classnames";
import { Loading } from "app/components/loading/loading";
import { titleize } from "app/utils/string";
import CreditCardFormModal from "../../../../components/dejavoo/cardDetailsModal";
import {useEffect, useState} from "react";


export interface PreAuthModalProps {
  setIsPreAuthModalOpen: (isOpen: boolean) => void;
  isProcessingCreditCardCharge: boolean;
  onPreAuthCreditCard: (res: any) => void;
}
export const PreAuthModal: React.FC<PreAuthModalProps> = ({
                                                              setIsPreAuthModalOpen,
                                                              isProcessingCreditCardCharge,
                                                              onPreAuthCreditCard,
                                                          }) => {
    const {  account } = usePreAuthModal();
    const [isValidated, setIsValidated] = useState(false)
    const [cardData, setCardData] = useState<any>({})


    useEffect(() => {
        console.log('card data--',cardData)

    }, [cardData]);

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">

            {isProcessingCreditCardCharge && (
                <div className="absolute top-1/3">
                    <Loading
                        label="Booking Appointment"
                        labelClassName="text-white"
                        type="brand"
                    />
                </div>
            )}

            <motion.div
                initial={{ scale: 0.95, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.2, ease: "easeInOut" }}
                className={classNames(
                    "flex w-[600px] max-w-full rounded-lg flex-col items-center gap-6 bg-white p-4 shadow-pop-up-shadow",
                    {
                        invisible: isProcessingCreditCardCharge,
                    }
                )}
            >
                <PaymentModalHeader
                    text="Reserve with your credit card"
                    buttonProps={{
                        onClick: () => setIsPreAuthModalOpen(false),
                    }}
                />

                <span className="text-body font-body text-neutral-700 text-center">
          To confirm your reservation, {titleize(account.name)} just needs a
          credit card on file. Don't worry, you won't be charged upfront!
        </span>

                <CreditCardFormModal
                    onCardValidationSuccess={setCardData}
                    secretKey={account.iposAuthToken}
                    freedomURL={process.env.REACT_APP_IPOS_FREEDOM_CREDIT_URL!}
                />

                <AsButton
                    disabled={isProcessingCreditCardCharge }
                    // disabled={!cardData?.payment_token_id || isProcessingCreditCardCharge}
                    loader={isProcessingCreditCardCharge}
                    className="h-14 w-full"
                    variant="default"
                    text="Book now"
                    size="lg"
                    onClick={() => onPreAuthCreditCard(cardData)}
                />
            </motion.div>
        </div>
    );
};
